import * as C from '../common';

export default data => {
  // TODO: Set defaults if blank

  return C.common_outgoing(data);
};
